// extracted by mini-css-extract-plugin
module.exports = {"bold":"style__bold__abyJm","button":"style__button__gNH+1","sendInfo":"style__sendInfo__hy-Ku","subNote":"style__subNote__S5Jjj"};